import 'regenerator-runtime/runtime';
import AnimateScroll from './components/AnimateScroll'
import ShowHide from './components/ShowHide'
import Cart from './components/Cart'
import Form from './components/Form'
import Calendar from 'tui-calendar'
import Modal from './components/Modal'

const Account = {
  init: () => {
    if (window.innerWidth > 767 && document.getElementById('account-calendar')) {
      Account.calendarInit()
    }

    document.addEventListener('click', Account.clickHandler)
  },
  clickHandler: (event) => {
    if (event.target.hasAttribute('data-cancel-enroll') && window.confirmModal) {
      window.confirming = {}
      window.confirming.url = `?cancel_enroll=${event.target.getAttribute('data-cancel-enroll')}&nonce=${event.target.getAttribute('data-nonce')}`
      window.confirming.title = 'Are you sure you want to cancel?'
      window.confirmModal.show()
    }
    if (event.target.hasAttribute('href')) {
      if ((event.target.href.indexOf('cancel_subscription') > -1) && (event.target.href.indexOf('confirm=true') < 0) && window.confirmModal) {
        event.preventDefault();
        window.confirming = {}
        window.confirming.url = `${event.target.href}&confirm=true`
        window.confirming.title = 'Are you sure you want to cancel?'
        window.confirmModal.show()
      }
    }
  },
  calendarInit: () => {
    window.calendar = new Calendar('#account-calendar', {
      usageStatistics: false,
      defaultView: 'month',
      taskView: true,
      isReadOnly: true,
      useDetailPopup: true,
      template: {
        time: (schedule) => {
          return `<div class="p-2 bg-c-purple-dark bg-opacity-25 border-l-4 border-c-purple-dark text-c-purple-dark leading-tight">
            ${schedule.title}<br>
            ${schedule.raw.start_display}
          </div>`
        },
        popupDetailDate: () => {
          return ''
        },
      },
    })

    Account.calendarUpdateClasses()
    document.addEventListener('click', Account.calenderClick)
  },
  calenderClick: (event) => {
    if (event.target.hasAttribute('data-calendar-control')) {
      const direction = event.target.getAttribute('data-calendar-control')
      if (direction === 'prev') {
        window.calendar.prev()
      }
      if (direction === 'next') {
        window.calendar.next()
      }
      const date = new Date(window.calendar.getDate().getUTCTime())
      document.getElementById('calendar-title').textContent = date.toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
      })
      Account.calendarUpdateClasses()
    }
  },
  calendarUpdateClasses: async () => {
    const dates = {
      start: window.calendar.getDateRangeStart().getTime(),
      end: window.calendar.getDateRangeEnd().getTime(),
    }
    const request = await Account.calendarGetClasses(dates)
    const response = JSON.parse(request)
    // console.log('response', response)

    window.calendar.clear()
    window.calendar.createSchedules(response)
  },
  calendarGetClasses: (dates) => new Promise((resolve) => {
    const request = `${window.settings.requestUrl}?action=get_attending_classes&date_start=${dates.start}&date_end=${dates.end}`
    // console.log('request', request)
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          // reject(xhr.status)
        }
      }
    };
    xhr.open('GET', request, true);
    xhr.send();
  }),
}

document.addEventListener('DOMContentLoaded', () => {
  AnimateScroll.init()
  ShowHide.init()
  Cart.init()
  Form.init()
  Account.init()
  Modal.init()
});
